// extracted by mini-css-extract-plugin
export default {"roundedButton":"RoundedButton_roundedButton__lcLw9","circle":"RoundedButton_circle__zUuSg"};